import { createSlice } from '@reduxjs/toolkit';

const operation = createSlice({
  name: 'operation',
  initialState: {
    operationTitle: null,
  },
  reducers: {
    setOperationTitle: (state, action) => {
      state.operationTitle = action.payload;
    },
    clearOperationTitle: (state) => {
      state.operationTitle = null;
    },
  },
});

export const { setOperationTitle, clearOperationTitle } = operation.actions;
export default operation.reducer;
